import React from 'react';
import BasicButton from 'common/components/Widgets/BasicButton/BasicButton';
import { ROOT_IMG_URL, ButtonBasicStyle } from '../../../GlobalValues';
import './SeeMore.css';

const SeeMore = () => {
  const seeMoreItems = [
    {
      picture: `${ROOT_IMG_URL}/seemore1.png`,
      title: "L'expérience VOG",
      link: 'https://vog.fr/experience-salon/',
    },
    {
      picture: `${ROOT_IMG_URL}/seemore2.png`,
      title: 'Le diagnostic',
      link: 'https://vog.fr/le-diagnostic-vog-coiffure/',
    },
  ];

  return (
    <section
      className="seemore-wrapper"
      style={{ backgroundColor: 'var(--primary-color)' }}
    >
      <div className="sl-container">
        <div className="box-wrapper sl-ai-center sl-jc-center">
          {seeMoreItems.map((item, index) => (
            <SeeMoreBox key={index} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
};

const SeeMoreBox = ({ item }) => {
  return (
    <article className="sl-relative">
      <a href={item.link}>
        <div
          className="sl-absolute sl-flex sl-ai-center sl-jc-center"
          style={{
            top: 0,
            left: 0,
            width: '100%',
            transform: 'translateY(-50%)',
          }}
        >
          <h3
            className="sl-title-bloc sl-title"
            style={{ width: 'fit-content' }}
          >
            {item.title}
          </h3>
        </div>
        <img
          src={item.picture}
          alt={item.title}
          loading="lazy"
          className="sl-contain-image"
        />
        <div
          className="sl-absolute sl-flex sl-ai-center sl-jc-center"
          style={{ bottom: '10%', left: '0', width: '100%' }}
        >
          <BasicButton
            label="EN SAVOIR PLUS"
            style={{
              ...ButtonBasicStyle,
              backgroundColor: 'var(--tertiary-color)',
              border: 'none',
            }}
          />
        </div>
      </a>
    </article>
  );
};

export default SeeMore;
